const PORTAL_KIOSK_KEY = "xsm_portal_kiosk_context";

export function setPortalKioskContext(payload) {
  sessionStorage.setItem(PORTAL_KIOSK_KEY, JSON.stringify(payload));
}

export function getPortalKioskContext() {
  const raw = sessionStorage.getItem(PORTAL_KIOSK_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function clearPortalKioskContext() {
  sessionStorage.removeItem(PORTAL_KIOSK_KEY);
}
